import React from "react";
import {
  setPage,
  setSelectedPayment,
  WashingStore,
} from "../../../../stores/WashingStore/WashingStore";
import TotemSkeleton from "../../components/TotemSkeleton/TotemSkeleton";
import TotemButton from "../../components/TotemButton/TotemButton";
import TotemOption from "../../components/TotemOption/TotemOption";
import { useUnit } from "effector-react";
import { WashOptionsContainer, TotalValue } from "./WashingPaymentStyles";
import { PAGES } from "../../../../stores/WashingStore/WashingStore.types";
import { paymentOptions } from "../../../../stores/WashingStore/WashingStore.consts";
import { toast } from "react-toastify";
import { PaymentOption } from "../../../../types/washing.types";

const WashingPayment: React.FC = () => {
  const { selectedPayment, finalPrice } = useUnit(WashingStore);

  const handleGoBack = () => {
    setPage(PAGES.CHOOSE_WASHING);
  };
  const handleConfirmPayment = () => {
    if (!selectedPayment?.type) {
      toast.error("Selecione uma forma de pagamento!");
      return false;
    }
    setPage(PAGES.WASHING_PAYMENT_LOADING);
  };

  const renderOptions = () =>
    paymentOptions.map((option: PaymentOption) => {
      const isselected = selectedPayment?.type === option.type;

      return (
        <TotemOption
          title={option.title}
          isselected={isselected}
          execSelection={() => setSelectedPayment(option)}
        />
      );
    });

  const Buttons = (
    <>
      <TotemButton negative onClick={() => handleGoBack()} text="Voltar" />
      <TotemButton
        onClick={() => handleConfirmPayment()}
        disabled={!selectedPayment?.type}
        text="Realizar Pagamento"
      />
    </>
  );

  const renderPrice = () => (
    <TotalValue>
      <p>Total</p>
      <p>R$ {finalPrice.toFixed(2)}</p>
    </TotalValue>
  );

  return (
    <TotemSkeleton title="Forma de Pagamento" buttons={Buttons}>
      <WashOptionsContainer>{renderOptions()}</WashOptionsContainer>
      {renderPrice()}
    </TotemSkeleton>
  );
};

export default WashingPayment;
